/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icn_schedule_map': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 15',
    data: '<path pid="0" data-name="Path 17335" d="M15 2h-2.5V1a1 1 0 10-2 0v1h-5V1a1 1 0 10-2 0v1H1a1 1 0 00-1 1v1h16V3a1 1 0 00-1-1z" _fill="#fff"/><path pid="1" data-name="Path 17336" d="M0 14a1 1 0 001 1h14a1 1 0 001-1V5H0zm11-7h2v2h-2zM7 7h2v2H7zm0 4h2v2H7zM3 7h2v2H3zm0 4h2v2H3z" _fill="#fff"/>'
  }
})
